import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import AntTime from '../utils/AntTime';
import AntLocalization from '../utils/AntLocalization';
import { SelectBox } from 'devextreme-react';
export default forwardRef(function (props, ref) {
    const initDataSource = () => {
        var obj = [];
        var current = AntTime.startOfCurrentYear();

        var fromYear = props.disabled ? -60 : -20;
        var toYear = props.disabled ? 30 : 10;
        for (let i = fromYear; i < toYear * 1; i++) {
            var m = AntTime.nextYears(current, i);
            obj.push({
                unix: m.unix(),
                value: m.year(),
                // display: (props.placeholder !== '...' ? 'Năm ' : '') + m.format('YYYY'),
                display: m.format('YYYY')
            });
        }
        obj = obj.sort((a, b) => (a.value < b.value ? 1 : -1));

        return obj;
    };

    const [dataSource] = useState(initDataSource());
    const [mainValue, setMainValue] = useState(props.defaultValue);

    return (
        <React.Fragment>
            <SelectBox
                items={dataSource}
                placeholder={props.placeholder}
                showClearButton={props.showClearButton}
                showDropDownButton={props.showDropDownButton}
                {...props.options}
                name={props.name}
                noDataText={AntLocalization.translateText({ vi: 'Không có dữ liệu !', en: 'Have no data !', fr: 'Aucune donnée !', es: '¡Sin datos!', id: 'Tidak ada data!', ja: 'データがありません！', zh: '没有数据！', ko: '데이터 없음!', hi: 'कोई डेटा नहीं!', ar: 'لا توجد بيانات!' })}
                displayExpr={'display'}
                valueExpr={'value'}
                value={mainValue}
                defaultValue={props.defaultValue}
                dropDownOptions={{
                    height: 250
                }}
                onFocusIn={(e) => {
                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                    if (inputEl) {
                        inputEl.selectionStart = 0;
                        inputEl.selectionEnd = inputEl.value.length;
                    }
                    if (props.onFocusIn)
                        props.onFocusIn({
                            dataField: props.dataField
                        });
                }}
                onValueChanged={(e) => {
                    var rowData = e.component.option('selectedItem');
                    if (e.value == null) {
                        setMainValue(null);
                        if (props.onValueChanged) {
                            props.onValueChanged({
                                value: null,
                                rowData: null,
                                previousValue: e.previousValue
                            });
                        }
                    } else {
                        setMainValue(e.value);
                        if (props.onValueChanged) {
                            props.onValueChanged({
                                value: e.value,
                                rowData: rowData,
                                previousValue: e.previousValue
                            });
                        }
                    }
                }}
            >
                {props.children}
            </SelectBox>
        </React.Fragment>
    );
});
